/* eslint-disable  @typescript-eslint/no-explicit-any */

import axios, { AxiosError } from 'axios';
import type { AxiosResponse } from 'axios';

import { COOKIES } from '@config';

import { setCookie, getRequestHeaders } from '@utils';

const API_BASE_URL = import.meta.env.VITE_API_URL;

export const useRequest = () => {
  return async <T> (
    url: string,
    {
      data = {},
      method = 'get',
      headers = {},
      params = {},
      signal,
    }: {
      data?: any;
      method?: string;
      headers?: any;
      params?: any;
      signal?: AbortSignal;
    } = {},
  ): Promise<AxiosResponse<T>> => {
    try {
      return await axios({
        baseURL: API_BASE_URL,
        headers: {
          ...getRequestHeaders(),
          ...headers,
        },
        url,
        data,
        params,
        method,
        signal,
      })
    } catch (error) {
      if (error instanceof AxiosError) {
        if (error?.response?.status === 401) {
          setCookie(COOKIES.AUTH_TOKEN, '');
        }
      }
      throw error;
    }
  };
};
